import { Brand } from './brand';
import { IsoCountryCode2Char } from './country-code';
import { localeToTldMap } from './generated/domains';
import { ILocale } from './locale';
import { Stage } from './stage';

export * from './generated/domains';

type BrandMapping = Record<Brand, string>;

interface IGetBrandDomain {
  brand: Brand;
  environment: Stage;
}

interface IGetDeepLink {
  brand: Brand;
}

export const BrandDomainMapDev: BrandMapping = {
  [Brand.BK]: 'https://dev.web.bk.rbi.tools/',
  [Brand.LTW]: 'https://dev.web.ltw.rbi.tools/',
  [Brand.PLK]: 'https://dev.web.plk.rbi.tools/',
  [Brand.TH]: 'https://dev.web.th.rbi.tools/',
  [Brand.FHS]: 'https://dev.web.fhs.rbi.tools/',
};

export const BrandDomainMapProd: BrandMapping = {
  [Brand.BK]: 'https://www.bk.com/',
  [Brand.LTW]: '',
  [Brand.PLK]: 'https://www.popeyes.com/',
  [Brand.TH]: 'https://timhortons.ca/',
  [Brand.FHS]: 'https://www.firehousesubs.com/',
};

export enum BrandDeepLinkPrefix {
  BK = 'burgerking://',
  LTW = 'ltw://',
  PLK = 'popeyes://',
  TH = 'timhortons://',
  FHS = 'firehousesubs://',
}

/**
 * Get the domain for given brand in given environment.
 * @deprecated use getDomain or getRBIDomain instead
 *
 * @param {IGetBrandDomain} options
 * * brand - the brand whose domain is needed.
 * * environment - the environment to look up domain in.
 *
 * @returns {string} The domain for the brand found in the environment lookup.
 */
export const getBrandDomain = ({ brand, environment }: IGetBrandDomain): string => {
  return environment === Stage.prod || environment === Stage.qa
    ? BrandDomainMapProd[brand]
    : BrandDomainMapDev[brand];
};

/**
 * Return the rbi development domain for the configured brand and stage.
 * @param brand
 * @param locale
 */
export const getRBIDomain = (brand: Brand, stage: Stage, locale: ILocale): string => {
  const normalizedLocale = (locale.region || '').toUpperCase();

  const tld = localeToTldMap.get(normalizedLocale as IsoCountryCode2Char);

  if (!tld) {
    throw new Error(`Unsupported country code ${normalizedLocale}`);
  }

  return `${stage}-${brand.toLowerCase()}-web.${tld}.rbi.tools`;
};

/**
 * Get the deep link prefix for given brand in given environment.
 *
 * @param {IGetDeepLink} options
 * * brand - the brand whose prefix is needed.
 * * stage - the environment to look up prefix in.
 *
 * @returns {string} The prefix for the brand found in the environment lookup.
 */
export const getBrandDeepLink = ({ brand }: IGetDeepLink): string => {
  return BrandDeepLinkPrefix[brand];
};
